import React from 'react';

import Typography from '../../../../library/typography/typography';
import CheckCircleSolidIcon from '../../../../shared/icons/check-circle-solid-icon';

import { useMyAccount } from '../../../../shared/hooks/hooks';

import {
  ProductData,
  PromotionConditionType
} from '../../../../shared/types/graphql-types';

import styles from './my-account-savings-applied-cart-message.scss';

interface MyAccountSavingsAppliedCartMessageProps {
  potentialPromotions?: ProductData['potentialPromotions'];
}

function MyAccountSavingsAppliedCartMessage(
  props: MyAccountSavingsAppliedCartMessageProps
) {
  const { potentialPromotions } = props;
  const { isLoggedIn } = useMyAccount();

  const hasMyAccountPromotion = potentialPromotions?.some(
    promotion =>
      promotion?.promotionConditionType === PromotionConditionType.Myaccount
  );

  if (!isLoggedIn || !hasMyAccountPromotion) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <CheckCircleSolidIcon className={styles['icon']} />
      <Typography tag="span">Instant savings applied in cart</Typography>
    </div>
  );
}

export default MyAccountSavingsAppliedCartMessage;
